module.exports = __webpack_public_path__ + "img/bg3.aa16c8d9.jpg";